define('ShareCart.Modal.View', [
    'sharecart_modal.tpl',
    'ShareCart.Model',
    'LiveOrder.Model',
    'Profile.Model',
    'Backbone',
    'underscore'
], function ShareCartModalView(
    shareCartModalTpl,
    ShareCartModel,
    LiveOrderModel,
    ProfileModel,
    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: shareCartModalTpl,
        initialize: function initialize(options) {
            this.application = options.application;
            this.model = new ShareCartModel();
            this.cart = options.cart;
            this.showEmailForm = true;
            this.showLink = false;
        },
        events: {
            'submit form': 'saveShareForm',
            'click [data-action="copy-link"]': 'copyLink'
        },
        bindings: {
            '[name="email"]': 'email'
        },
        saveShareForm: function saveShareForm(e) {
            var self = this;
            var items;
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var storeId = (store && store.get('internalid')) ? store.get('internalid') : null;

            e.preventDefault();
            e.stopPropagation();

            this.model.set('emails', [this.$('[name="email"]').val()]);
            this.model.set('store', storeId);
            this.cart.getLines().then(function then(lines) {
                items = _.map(lines, function map(line) {
                    return {
                        description: '',
                        options: line.options,
                        quantity: line.quantity,
                        item: {
                            internalid: line.item.internalid
                        }
                    };
                });
                self.model.set('items', items);
                self.inModal = false;
                Backbone.View.prototype.saveForm.apply(self, [e, self.model]).done(function done() {
                    self.showEmailForm = false;
                    self.showLink = true;
                    self.model.set('fullLink', location.origin + '/cart?hash=' + self.model.get('publicId'));
                    self.render();
                }).always(function always() {
                    self.inModal = true;
                });
            });
        },
        copyLink: function copyLink() {
            document.querySelector('[data-type="input-link"]').select();
            document.execCommand('copy');
        },
        getContext: function getContext() {
            return {
                showEmailForm: this.showEmailForm,
                showLink: this.showLink,
                model: this.model
            };
        }
    });
});
